export default __webpack_public_path__ + "static/media/charlesdeluvio-Lks7vei-eAg-unsplash.db8058e3.jpg";